import { SidebarToggleOpenReducer } from './types';

export const sidebarToggleOpenReducer: SidebarToggleOpenReducer = (
  state,
  action
) => {
  const { isOpen } = action.payload;

  return {
    ...state,
    isOpen,
  };
};
